<template>
  <div class='metricDetail'>
    <div class="bg">
    <div class="table-box">
      <p class="top-title">Report of  <span>{{ titleName }}</span>  <span>{{ dateTime }}</span></p>
      <el-table class="table" v-show="namesList.length > 0" ref="dragTable" :data="namesList" v-loading="loading"
        element-loading-background="rgba(255, 255, 255, 0.8)" border width="100%" fit 
        :header-cell-style="{
          background: '#ECF2FE',
          borderColor: '#999999',
          color: '#383838',
          fontSize: '16px',
          fontWeight: 'bold',
        }" 
        :cell-style="{
          borderColor: '#999999',
          fontSize: '15px',
          fontWeight: '400',
          color: '#383838',
        }"
        @row-click="rowClick">
        <el-table-column align="center" width="220">
          <template #header>
            <div class="table-header-title">Name</div>
          </template>
          <template #default="scope">
            <div class="table-name">{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" v-for="title in headerTitles" :key="title">
          <template #header>
            <div class="table-header-title">{{ title }}</div>
          </template>
          <template #default="scope">
            <div v-for="(model, index) in columnModel(scope.row.name, title)" :class="columnModel(scope.row.name, title)?.length == index + 1 ? 'row-box-last': 'row-box'" :key="model">
              <p class="row-time">{{ localDate(model.created_at) }}</p>
              <div class="row--link"><a :href="model.url" target="_blank"> {{ model.title }}</a></div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
  </div>
</template>
<script>
import {
  getQueryStatus,
  newDownLoadFile
} from "@/request/api";
import {
  getUrlData
} from "@/request/axiosApi";
import { ResourceType } from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
import moment from "moment";
export default {
  name: 'metricDetail',
  data() {
    return {
      dataList: [],
      headerTitles: [],
      namesList: [],
      loading: false,
      titleName: '',
      dateTime: '',
    }
  },
  computed: {
    localDate() {
      return time => {
        return moment.utc(time).local().format('YYYY-MM-DD HH:mm:ss')
      }
    },
    columnModel() {
      return (name, title) => {
        const list = this.dataList.filter(m => {
          return m.name == title
        })
        if (list.length > 0) {
          return list[0]?.item[name]
        }
        return []
      }
    }
  },
  methods: {
    
  },
  async created() {
    this.loading = true
    const id = this.$route.params.id
    try {
      const queryData = await getQueryStatus(id, ResourceType.DATA)
      const metricModel = queryData.data
      for (const map of metricModel?.annotationsMap) {
        if (map[0]?.trim().toLocaleLowerCase() == "title") {
          this.titleName = map[1];
        } 
      }
      document.title = `aqua.${this.titleName}`
      const ossKey = metricModel.ossfile?.key
      const fileName = metricModel.ossfile?.originname
      const url = await newDownLoadFile(ossKey, fileName)
      const data = await getUrlData(url)
      console.log("Object.entries(data)  = ", Object.entries(data))
      this.dateTime = data?.date
      const list = []
      for (const [key, value] of Object.entries(data)) {
        if (typeof value == "object") {
          this.headerTitles.push(key)
          const model = {
            name: key,
            item: value,
          }
          list.push(model)
        } 
      }
      if (list.length > 0) {
        const item = list[0].item
        for (const [key, value] of Object.entries(item)) {
          if (Array.isArray(value)) {
            const model = {
              name: key
            }
            this.namesList.push(model)
          }
        }
      }
      this.dataList = list
    } catch (error) {
      console.log(error)
    }
    this.loading = false
  }
}
</script>
<style lang='less' scoped>
.metricDetail {
  display: flex;
  width: 100vw;
  justify-content: center;
  flex-direction: column;
  margin: auto;
}

.bg {
  padding: 35px 70px 10px 70px;
  background-color: #f5f5f5;
  width: 100%;
  min-width: 800px;
  max-width: 2600px;
  margin: auto;
}

.table-box {
  padding: 20px 30px 30px 30px;
  background-color: #ffffff;
  border-radius: 3px;
  width: 100%;
}

.top-title {
  color: #000;
  font-size: 16px;
  font-weight: 500;
  padding-left: 5px;
  text-align: left;
  span {
    color: #0052d9;
    font-weight: 600;
  }
}

.table {
  margin-top: 15px;
  width: 100%;
  border: 1px solid #999999;
  .table-header-title {
    font-size: 16px;
  }
  .table-name {
    color: #000000;
    font-size: 15px;
  }
  .row-box {
    display: flex;
    flex-direction: column;
    padding-bottom: 15px;
  }
  .row-box-last {
    display: flex;
    flex-direction: column;
  }
  .row-time {
    font-size: 13px;
    color: #000;
  }
  .row--link {
    font-size: 14px;
    line-height: 20px;
    a {
      color: #0052d9;
      font-weight: 500;
    }
  }
}

:deep(.el-table th) {
  user-select: initial !important;
  height: 70px !important;
}
  
</style>